import CardBlog, {
  Props as CardBlogProps
} from '../../Molecules/CardBlog';

interface Props {
  posts?: CardBlogProps[];
}

function CardBlogList({ posts }: Props) {
  return (
    <div className="flex w-full flex-col items-center justify-center gap-10 py-7">
      <div className="mx-auto flex w-full max-w-7xl flex-wrap items-stretch justify-between gap-4 px-7 md:grid md:gap-7 lg:grid-cols-2">
        {posts?.map((post) => (
          <CardBlog key={posts.indexOf(post)} {...post} />
        ))}
      </div>
    </div>
  );
}

export default CardBlogList;
